import { useState } from 'react';
import { Modal, Box } from '@mui/material';
import { Close } from '@mui/icons-material';
import { CheckIcon } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import { updateAuth } from '../redux/authSlice';

const style = {
    position: 'absolute',
    top: '30%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    boxShadow: 1,
    p: '36px 20px 40px 20px',
    color: '#FFF',
    borderRadius: '8px'
};

const Languages = [
    {
        id: 1,
        language: 'English',
        icon: ''
    },
    {
        id: 2,
        language: 'Hindi',
        icon: ''
    },
    {
        id: 3,
        language: 'Marathi',
        icon: ''
    },
    {
        id: 4,
        language: 'Telugu',
        icon: ''
    },
    {
        id: 5,
        language: 'Odia',
        icon: ''
    },
]

const LanguageSelector = () => {
    const [openForgotPwd, setOpenForgotPwd] = useState(false);
    const openRegister = useSelector(state => state.auth.openRegister);
    const openLang = useSelector(state => state.auth.openLanguage);
    const selectedLanguage = useSelector(state => state.auth.selectedLang);
    const [formErrors, setFormErrors] = useState({});
    const dispatch = useDispatch();
    const [registerForm, setRegisterForm] = useState({ phoneNumber: '', password: '' });
    const handleClose = () => dispatch(updateAuth({ openLanguage: false }));

    const onSelectLanguage = (value) => {
        dispatch(updateAuth({ selectedLang: value }))
    }

    return (
        <>
            <Modal open={openLang} onClose={null}>
                <Box sx={style}
                    className="bg-[#152234] w-11/12 md:w-[400px] box-border p-6 rounded-lg shadow-lg text-white"
                    style={{ position: 'relative' }}
                >
                    <div className='register-head'>
                        <button className='absolute z-10 top-2 right-2' onClick={handleClose}>
                            <Close color='#ffffff4d' />
                        </button>
                        <div className='text-2xl font-bold text-left border-b pb-3'>
                            Language
                        </div>
                    </div>
                    <div className=''>
                        {Languages.map(item => (<div className={`py-2 font-medium ${selectedLanguage === item.language ? 'text-blue-500' : ''} border-b`} onClick={() => onSelectLanguage(item.language)}>
                            <img src=".." alt="" />
                            <div className='flex justify-between'>
                                {item.language}
                                {selectedLanguage === item.language && <CheckIcon />}
                            </div>
                        </div>))}
                    </div>
                </Box>
            </Modal>
        </>
    )
}

export default LanguageSelector